import { ShareCaseConfig, ShareCaseArgs } from './types';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { routeConstants } from 'app/routes/route-constants';
import { api } from './api';
import { getUserMessage } from 'app/infrastructure/notifications/user-messages/get-user-message';
import { toastFactory } from 'app/infrastructure/notifications/toast-factory';

const toasts = toastFactory();

export const SharePreset: { [key: string]: ShareCaseConfig } = {
  case: {
    getUsers: async (
      caseNumber: number,
      filterText?: string
    ) => {
      try {
        return await api.getUsersForShareLink(caseNumber, filterText);
      }
      catch (err) {
        toasts.dispatchError(getUserMessage(err.userMessages));
        return [];
      }
    },
    shareDocument: async (
      props: ConnectedComponentProps & { caseNumber: number },
      args: Partial<ShareCaseArgs>,
      translate: { [key: string]: string }
    ) => {

      toasts.dispatchInfo(translate.case_was_shared);
      const caseNumber = props?.caseNumber || args?.caseId;

      try {
        await api.shareDocument({
          caseId: caseNumber,
          linkPath: routeConstants.caseViewFor(caseNumber),
          message: args.message,
          recipients: args.recipients
        });
      } catch (err) {
        toasts.updateError(getUserMessage(err.userMessages) || translate.share_failed);
      }
    }
  },
  draft: {
    getUsers: async (
      draftId: number,
      filterText?: string,
      domainNoUsers?: number
    ) => {
      try {
        return await api.getUsersForShareLinkDraft(draftId, domainNoUsers, filterText);
      }
      catch (err) {
        toasts.dispatchError(getUserMessage(err.userMessages));
        return [];
      }
    }
  }
};
